<template>
  <div></div>
</template>

<script>
import Vue from "vue";
import Plugin from "./donation";
import firebase from "firebase/app";

Vue.use(Plugin);

export default {
  mounted: function() {
    let $this = this;
    let firstTime = true;

    firebase
      .firestore()
      .collection("notification")
      .doc("donation")
      .onSnapshot(function(notificationDonationSnapshot) {
        if (firstTime) {
          firstTime = !firstTime;
          return;
        }

        notificationDonationSnapshot
          .data()
          .donationRef.get()
          .then(function(donationSnapshot) {
            let donation = donationSnapshot.data();
            Promise.all([donation.from.get(), donation.to.get()])
              .then(function(dataSnapshot) {
                let user = dataSnapshot[0].data();
                let company = dataSnapshot[1].data();

                $this.$toast.open({
                  user: {
                    name: user.name,
                    photoURL: user.photoURL
                  },
                  company: {
                    name: company.name
                  },
                  duration: 4000,
                  position: "bottom",
                  queue: true
                });
              })
              .catch(function(error) {
                console.log("Error getting documents: ", error);
              });
          })
          .catch(function(error) {
            console.log("Error getting documents: ", error);
          });
      });
  }
};
</script>

<style>
</style>